export default "__VITE_PUBLIC_ASSET__e78f8c7f__"